export default {
      id: "mute-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "icons.HITByrwA.svg#mute-usage",
      toString: function () {
        return this.url;
      }
    }